import * as angular from "angular";
import {IController} from "angular";

export class ShipperLinkCtrl implements IController {
  shipper: any;
}

angular
  .module('bringoz.admin.shippers')
  .component('shipperLink', {
    bindings: {
      shipper: '<'
    },
    template: require('./shipper-link.html').default,
    controller: ShipperLinkCtrl
  });
